import {MadnesInterface} from "./libs/mi/MadnesInterface";
import ServerConfig from "./ServerConfig";
import GameConfig from "./game/GameConfig";
import SymbolsManager from "./symbol/SymbolsManager";
import Game from "./game/Game";
import Preinfo from "./game/Preinfo";
import GameAssets from "./game/GameAssets";
import GameInfo from "./game/GameInfo";
import {madnes_set_audio_volume} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_key_exist, madnes_remove_sprite} from "../framework/src/engine/madnes/madnes_object";
import ReelPrinter from "./reel/ReelPrinter";
import SpinReels from "./reel/SpinReels";
import BigWin from "./game/BigWin";
import {systemConfig} from "../framework/src/engine/madnes/madnes_variables";
import {CONFIG_PARAMS} from "../framework/src/system/SystemConfig";

document.addEventListener(window.visibilityChange, playPauseGame, false);

// window.gameReady = false;

/** @type MadnesInterface  */
export var MI = new MadnesInterface();
MI.init();

/** @type {ServerConfig} */
var serverConfig = new ServerConfig();

var game = new Game();
var preinfo = new Preinfo();


export var gameInfo = new GameInfo();
export var gameConfig = new GameConfig();
export var symbolsManager = new SymbolsManager();

function playPauseGame() {
    if(main_phaser) {

        if(document[hiddenName]) {
            main_phaser.paused = true;
        } else {
            main_phaser.paused = false;
        }
    }
}

set_gray_filter();

/**
 * @param {string} dname
 * @param {number} ver
 */
function init_game(dname, config, ver) {

    //game.ready = false;

    // if(typeof ver === 'undefined') {
    // 	ver = 1;
    // }

    // madnes_add_fontface_preload("pakenhamregular");

    // last_round_autostart_enabled = !gameConfig.showPreinfo;

    // MI.setTextureVersion(ver);
    // MI.setNativeScreenSize(1280, 720);
    //
    // madnes_config_load_symbols = false;

    //madnes_set_languages(['en', 'cs', 'sk']);
    // madnes_set_def_lang('en');
    // madnes_load_init("alchemy", config);
    //
    // delete to_load_fonts_madnes["win_font"];
    // delete to_load_madnes["coin_sprite"];
    // //delete to_load_madnes["win_font_bg"];
    //
    // for(var i in to_load) {
    // 	madnes_add_to_load(i, to_load[i]);
    // }
    //
    // for(var i in to_load_json_atlas) {
    // 	madnes_add_json_atlas_to_load(i, to_load_json_atlas[i][0], to_load_json_atlas[i][1]);
    // }
    //
    // for(var i in to_load_spritesheets) {
    // 	madnes_add_spritesheet_to_load(i, to_load_spritesheets[i]['url'], to_load_spritesheets[i]['w'], to_load_spritesheets[i]['h']);
    // }
    //
    // for(var i in to_load_fonts) {
    // 	madnes_add_font_to_load(i, to_load_fonts[i]);
    // }
    //
    // for(var i in to_load_json)
    // {
    // 	if(infotexts_languages.indexOf(lang) === -1)
    // 	{
    // 		to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
    // 	}
    //
    // 	madnes_add_json(i, to_load_json[i]);
    // }
    //
    // for(var i in to_load_audio)
    // {
    // 	madnes_add_audio(i, to_load_audio[i]);
    // }
    //
    // delete to_load_audio_madnes['coins_loop'];

    //madnes_set_load_complete_function(ctrl_init_bonus);

    // madnes_set_printdesk_function(init_desk);
    // madnes_set_updatedesk_function(function() {});
    //
    // madnes_set_rotate_function(rotateRun);
    //
    // madnes_set_infomenu_init_function(infomenuInit);
    // madnes_set_infomenu_update_function(infomenuUpdate);
    // madnes_set_infomenu_open_function(infomenuOpen);
    // madnes_set_infomenu_close_function(infomenuClose);
    // madnes_set_infomenu_left_function(infomenuLeft);
    // madnes_set_infomenu_right_function(infomenuRight);
    //
    // madnes_set_on_rotate_release(rotateRelease);
    // madnes_set_on_forcestop_press(forcestopPress);
    //
    // madnes_set_preinfo_close_function(preinfoClose);
    //
    // madnes_set_game_ready_function(function() {
    // 	//game.ready = true;
    // 	if(is_last_round_autostart() && !game.inPreinfo) {
    // 		madnes_rotate_start();
    // 	}
    // });

    /*
    madnes_set_betmenu_choose_function(betmenu_choose);
    madnes_set_betmenu_open_function(betmenu_open);
    madnes_set_on_key_down_function(ctrl_on_key_down);
    */

    // madnes_init(dname);
    // set_gray_filter();
}
window["init_game"] = init_game;


export function alch_init_desk() {

    //setTimeout(clearMadnesObjects, 3000);

    var gameAssets = new GameAssets(gameConfig);
    preinfo.init(gameAssets);

    serverConfig.setServerConfig(MI.server.getConfig());

    MI.setBigWinFactors(
        serverConfig.getMinBigWinFactor(),
        serverConfig.getMinMegaWinFactor(),
        serverConfig.getMinSuperMegaWinFactor()
    );

//	if(serverConfig.getBetSet()) {
//		//console.log(serverConfig.getBetSet());
//		//madnes_init_bets(serverConfig.getBetSet());
//	}

    // bets = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

    configSounds(serverConfig);

    gameAssets.createReelsBg();

    var reelPrinter = new ReelPrinter(gameConfig);

    var spinReels = new SpinReels();


    symbolsManager.init(spinReels);

    spinReels.init(game, reelPrinter, gameConfig, serverConfig, symbolsManager);
    game.init(spinReels, gameConfig, reelPrinter, serverConfig, symbolsManager, gameAssets);

    gameAssets.createFreeSpinGroupBack();

    spinReels.createReels();
    gameAssets.createFreeSpinSearch();
    gameAssets.createMultiReelsGroup();

    gameAssets.createMillGroup();
    gameAssets.createBigWinGroup();

    gameAssets.createFliesGroup();
    gameAssets.createAlchemistGroup();

    gameAssets.createBonusParticlesGroup();
    gameAssets.createBonusGroup();

    gameAssets.createReelCover();

    gameAssets.createFreeSpinGroupFront();
    gameAssets.createLightFrames();
    gameAssets.colorizeAllFrames(spinReels);

    gameAssets.createFrameFires();
    gameAssets.createFsInfoGroup();

    gameAssets.createLogo();

    if(gameConfig.showPreinfo) {
        // inpreinfo = true;
        preinfo.create();
    } else {
        preinfo = null;
        spinReels.createAndPlayStandAnims();
    }

    var bw = new BigWin(game);
    bw.createFreeSpin();

//	var c = new WinCounter();
//	c.setOnUpdate(function(v) {
//		console.log(v);
//	});
//	c.setOnEnd(function(v) {
//		console.log(v);
//	});
//	c.run(0, 500, 5000);
}

function rotateRelease() {
    game.spinReleased();
}

function forcestopPress() {
    game.forcestopPressed();
}

export function preinfoClose() {

    //console.log(Object.keys(madnes_objects).length);
    // game.spinReels.createAndPlayStandAnims();

    // inpreinfo = false;

    // last_round_autostart_enabled = true;
    // if(is_last_round_autostart()) {
    // 	madnes_rotate_start();
    // }

    preinfo.stopAutorun();
    preinfo.close();

    preinfo = null;
}

export function infomenuInit() {
    gameInfo.init(serverConfig, symbolsManager);
    gameInfo.create();
}

export function infomenuUpdate() {
    gameInfo.update(MI.getBet());
}

export function infomenuOpen() {
    // if (systemConfig.get(CONFIG_PARAMS.DISPLAYS) !== 2) {
    //     game.spinReels.stopStandAnim();
    //     game.spinReels.visibleReelSymbols(false);
    //
    //     //game.spinReels.destroyReelSymbols();
    //
    //     game.assets.reelsBg.setVisible(false);
    //     game.assets.visibleReelCover(false);
    //     game.assets.visibleLightFrames(false);
    //     game.assets.visibleFrameFires(false);
    // }

    // gameInfo.create();
    gameInfo.update(MI.getBet());
    gameInfo.open();
}

export function infomenuClose() {

    // game.assets.reelsBg.setVisible(true);
    // game.assets.visibleReelCover(true);
    // game.assets.visibleLightFrames(true);
    // game.assets.visibleFrameFires(true);
    //
    // game.spinReels.visibleReelSymbols(true);
    // game.spinReels.createAndPlayStandAnims();

    //game.spinReels.reinitReelsSymbols();
    //game.spinReels.printReels();

    gameInfo.close();
    // gameInfo.destroy();
}

export function infomenuLeft() {
    gameInfo.slideLeft();
}

export function infomenuRight() {
    gameInfo.slideRight();
}

export function infomenuHome() {
	gameInfo.showMain();
}

export function rotateRun() {
    game.spinStart();
}

/** @param {ServerConfig} serverConfig */
function configSounds(serverConfig) {
    var vol = serverConfig.getVolumeBigWin();

    madnes_set_audio_volume('bwin_BigWin', vol);
    madnes_set_audio_volume('bwin_BigWin_End', vol);
    madnes_set_audio_volume('bwin_FreeSpins', vol);

    vol = serverConfig.getVolumeButtonEffect();
    madnes_set_audio_volume('button_click', vol);

    vol = serverConfig.getVolumeSpin();
    madnes_set_audio_volume("reel_Spin", vol);

    vol = serverConfig.getVolumeStartReel();
    madnes_set_audio_volume("reel_Start", vol);

    vol = serverConfig.getVolumeStopReel();
    madnes_set_audio_volume("reel_Stop", vol);

    vol = serverConfig.getVolumeWinAnim();
    madnes_set_audio_volume("win_BlueCrystal_2x", vol);
    madnes_set_audio_volume("win_BlueCrystal_3x", vol);
    madnes_set_audio_volume("win_BlueCrystal_4x", vol);
    madnes_set_audio_volume("win_BlueCrystal_5x", vol);
    madnes_set_audio_volume("win_BlueCrystal_5x", vol);
    madnes_set_audio_volume("win_Candle_3x", vol);
    madnes_set_audio_volume("win_Candle_4x", vol);
    madnes_set_audio_volume("win_Candle_5x", vol);
    madnes_set_audio_volume("win_Candle_3x", vol);
    madnes_set_audio_volume("win_Coin_2x", vol);
    madnes_set_audio_volume("win_Coin_3x", vol);
    madnes_set_audio_volume("win_Coin_4x", vol);
    madnes_set_audio_volume("win_Coin_5x", vol);
    madnes_set_audio_volume("win_FlaskHigh_3x", vol);
    madnes_set_audio_volume("win_FlaskHigh_4x", vol);
    madnes_set_audio_volume("win_FlaskHigh_5x", vol);
    madnes_set_audio_volume("win_FlaskLow_3x", vol);
    madnes_set_audio_volume("win_FlaskLow_4x", vol);
    madnes_set_audio_volume("win_FlaskLow_5x", vol);
    madnes_set_audio_volume("win_FlaskMid_3x", vol);
    madnes_set_audio_volume("win_FlaskMid_4x", vol);
    madnes_set_audio_volume("win_FlaskMid_5x", vol);
    madnes_set_audio_volume("win_Pestle_3x", vol);
    madnes_set_audio_volume("win_Pestle_4x", vol);
    madnes_set_audio_volume("win_Pestle_5x", vol);
    madnes_set_audio_volume("win_RedCrystal_2x", vol);
    madnes_set_audio_volume("win_RedCrystal_3x", vol);
    madnes_set_audio_volume("win_RedCrystal_4x", vol);
    madnes_set_audio_volume("win_RedCrystal_5x", vol);
    madnes_set_audio_volume("win_Ring_2x", vol);
    madnes_set_audio_volume("win_Ring_3x", vol);
    madnes_set_audio_volume("win_Ring_4x", vol);
    madnes_set_audio_volume("win_Ring_5x", vol);
    madnes_set_audio_volume("win_Multiplier", vol);

    vol = serverConfig.getVolumeWinCounter();
    madnes_set_audio_volume("remittance_A", vol);
    madnes_set_audio_volume("remittance_B", vol);
    madnes_set_audio_volume("bonus_FreeSpins_Counter", vol);

    vol = serverConfig.getVolumeBackground();
    madnes_set_audio_volume("bg_Music", vol);
    /*madnes_set_audio_volume("bg_Layer_1", vol);
    madnes_set_audio_volume("bg_Layer_2", vol * 0.7);*/

    vol = serverConfig.getVolumeFSBackground();
    madnes_set_audio_volume("bg_FreeSpins_Loop", vol);
    madnes_set_audio_volume("bg_FreeSpins_Start", vol);

    vol = serverConfig.getVolumeBonusBackground();
    madnes_set_audio_volume("bg_Scatter_Idle", vol);

    vol = serverConfig.getVolumeMiscSound1();
    madnes_set_audio_volume("symbol_Wild", vol);
    madnes_set_audio_volume("symbol_Wild_Start", vol);
    madnes_set_audio_volume("symbol_Scatter_1", vol);
    madnes_set_audio_volume("symbol_Scatter_2", vol);
    madnes_set_audio_volume("symbol_Scatter_3", vol);

    vol = serverConfig.getVolumeMiscSound2();
    madnes_set_audio_volume("bonus_Scatter_Pick", vol);
    madnes_set_audio_volume("bonus_Paper_1", vol);
    madnes_set_audio_volume("bonus_Paper_2", vol);
    madnes_set_audio_volume("bonus_Paper_3", vol);
    madnes_set_audio_volume("win_Expand_1", vol);
    madnes_set_audio_volume("win_Expand_2", vol);
    madnes_set_audio_volume("win_Expand_3", vol);

    vol = serverConfig.getVolumeMiscSound3();
    madnes_set_audio_volume("win_Multiplier", vol);

    vol = serverConfig.getVolumeMiscSound4();
    madnes_set_audio_volume("bonus_Wild_Random", vol);
    madnes_set_audio_volume("bonus_Wild_Expand_Online", vol);
    madnes_set_audio_volume("bonus_Wild_Shuffle", vol);
    madnes_set_audio_volume("bonus_Wild_Changing_1", vol);
    madnes_set_audio_volume("bonus_Wild_Changing_2", vol);
    madnes_set_audio_volume("bonus_Wild_Changing_3", vol);
    for(var i = 1; i <= 15; i++) {
        madnes_set_audio_volume("bonus_Wild_Changing_3_" + i, vol);
    }

    vol = serverConfig.getVolumeMiscSound5();
    madnes_set_audio_volume("bonus_Scatter_1", vol);
    madnes_set_audio_volume("bonus_Scatter_2", vol);
    madnes_set_audio_volume("bonus_Scatter_3", vol);
}

function clearMadnesObjects() {

    madnes_key_exist("preloader_logo") && madnes_remove_sprite("preloader_logo");
    madnes_key_exist("preloader_logo0_mask") && madnes_remove_sprite("preloader_logo0_mask");

    for(var i = 1; i <= 6; i++) {

        if(madnes_key_exist("preloader_lens_a_" + i)) {
            madnes_remove_sprite("preloader_lens_a_" + i);
        }

        if(madnes_key_exist("preloader_lens_b_" + i)) {
            madnes_remove_sprite("preloader_lens_b_" + i);
        }
    }
}

function set_gray_filter() {

    /**
     * This turns your displayObjects to grayscale.
     * @class Gray
     * @contructor
     */
    Phaser.Filter.Gray = function (game) {

        Phaser.Filter.call(this, game);

        this.uniforms.gray = { type: '1f', value: 1.0 };

        this.fragmentSrc = [

            "precision mediump float;",

            "varying vec2       vTextureCoord;",
            "varying vec4       vColor;",
            "uniform sampler2D  uSampler;",
            "uniform float      gray;",

            "void main(void) {",
            "gl_FragColor = texture2D(uSampler, vTextureCoord);",
            "gl_FragColor.rgb = mix(gl_FragColor.rgb, vec3(0.2126 * gl_FragColor.r + 0.7152 * gl_FragColor.g + 0.0722 * gl_FragColor.b), gray);",
            "}"
        ];
    };

    Phaser.Filter.Gray.prototype = Object.create(Phaser.Filter.prototype);
    Phaser.Filter.Gray.prototype.constructor = Phaser.Filter.Gray;

    /**
     * The strength of the gray. 1 will make the object black and white, 0 will make the object its normal color
     * @property gray
     */
    Object.defineProperty(Phaser.Filter.Gray.prototype, 'gray', {

        get: function() {
            return this.uniforms.gray.value;
        },

        set: function(value) {
            this.uniforms.gray.value = value;
        }

    });
}

/**
 * @class MO
 * @extends Phaser.Sprite
 * @constructor
 * @returns {undefined}

 function MO(game, x, y, key, frame) {
	Phaser.Sprite.call(this, game, x, y, key, frame);
}

 MO.prototype = Object.create(Phaser.Sprite.prototype);
 MO.prototype.constructor = MO;
 */